export default __webpack_public_path__ + "static/afterglow-banner-mobile-2022138467419a1d754c3f6a8130ba55.webp";